import React, { useEffect, useState } from 'react'
import TabsHomePage from '../components/tabsHomePage/tabsHomePage'
import { useNavigate } from 'react-router-dom'
import { LoadingBar, BufferService } from 'src/M_Components'
import { FavoritesCache } from 'src/M_Components/M_FormFavorites/favoritesCache'

export default function HomePage() {
    const navigate = useNavigate()
    const roleService = new BufferService('identity/userrole')
    const userConfigService = new BufferService('userpreferences')
    const [isLoaded, setIsLoaded] = useState(true)
    const [permissions, setPermissions] = useState([])
    const [userConfigs, setUserConfigs] = useState([])

    const loadUserPreferences = async (userId) => {
        try {
            const configs = await userConfigService.getId(userId)
            // console.log('User Preferences:', configs)

            const isActiveSession = sessionStorage.getItem('isActiveSession')
            if (isActiveSession === 'true') {
                // console.log('Active session detected - keeping sessionStorage tabs')
                setUserConfigs({
                    ...configs,
                    OpenTabs: [] 
                })
            } else {
                // console.log('New login - loading tabs from DB')
                sessionStorage.setItem('isActiveSession', 'true')
                setUserConfigs(configs)
            }

            // Carregar favoritos para cache (1x no login)
            await FavoritesCache.loadAll()
            // console.log('Favorites loaded to cache')
        } catch (error) {
            console.error('Error loading user preferences', error)
        } finally {
            setIsLoaded(false)
        }
    }

    const reloadTablesOrder = (newOrderRecord) => {
        if (newOrderRecord) {
            setUserConfigs(prev => {
                const existing = prev?.TablesOrder || []
                const idx = existing.findIndex(o => o.PageUrl === newOrderRecord.PageUrl)
                const updated = idx >= 0
                    ? existing.map((o, i) => i === idx ? newOrderRecord : o)
                    : [...existing, newOrderRecord]
                return { ...prev, TablesOrder: updated }
            })
            // console.log('Tables Order updated locally:', newOrderRecord)
        }
    }

    useEffect(() => {
        roleService.get().then(res => {
            // console.log('INFO', res)
            if (res.name === 'AxiosError') {
                localStorage.removeItem("tokenMaeil")
                navigate('/login')
            }
            if (res.User && res.Tenant && res.RoleDetails) {
                sessionStorage.setItem('companies', JSON.stringify(res.Companies))
                sessionStorage.setItem('userRoleNames', JSON.stringify((res.Role || []).map(r => r.Name)))
                localStorage.setItem("accountName", res.User.UserName)
                localStorage.setItem("accountEmail", res.User.Email || res.User.UserName || "")
                localStorage.setItem("accountCompany", res.Tenant)
                localStorage.setItem("userId", res.User.Id)
                setPermissions(res.RoleDetails.map(roles => { return roles.Value }))
                loadUserPreferences(res.User.Id)
                //setIsLoaded(false)
            } else {
                setIsLoaded(false)
                localStorage.removeItem("tokenMaeil")
                navigate('/login')
            }
        })
        // eslint-disable-next-line
    }, [])

    return (
        <>
            {isLoaded ? (<LoadingBar />) : (<TabsHomePage roles={permissions} initialTabs={userConfigs?.OpenTabs || []} tablesOrder={userConfigs?.TablesOrder || []} onTablesOrderUpdate={reloadTablesOrder} />)}
        </>
    )
}